import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class ExportProductWithSpecArgs extends ActionArgs {
  @Field(() => String)
  productId: string
}

export interface IExportProductWithSpec extends IAction<string, ExportProductWithSpecArgs> {}
